import { create } from 'zustand';
import type { IExportState, StateType } from '@/version-types';
import { getState, useState } from '../context';

/** 存储类型 */
interface IStore {
    id: string;
}

/** 创建存储 */
const createState = (identity: string) => {
    return create<IStore>((set, get) => ({
        id: identity,
    }));
};

/** 存储名称 */
const name = 'editor-identity-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取 id */
export const useIdentityState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getIdentityState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

/** 导出存储 */
export default {
    name,
    createState,
} as IExportState;
